import equal from 'fast-deep-equal';
import { JSONSchema7 } from 'json-schema';

export type SchemaWithDefinitions = {
  definitions?: Record<string, unknown>;
};

export function extractMixins(schemas: SchemaWithDefinitions[]): Record<string, unknown> {
  const definitions = {} as Record<string, unknown>;
  const nameToSchema = {} as Record<string, unknown>;

  for (const schema of schemas) {
    for (const [name, definition] of Object.entries(schema.definitions ?? {})) {
      if (name in definitions && !equal(definitions[name], definition)) {
        throw new Error(
          `Schema ${JSON.stringify(nameToSchema[name])} already has mixin with name: ${name}, but ${JSON.stringify(
            schema,
          )} has mixin with that name too!`,
        );
      }
      definitions[name] = definition;
    }
  }

  return definitions;
}

export function mixinToNormalForm<T extends JSONSchema7['properties']>(mixin: T): { type: 'object'; properties: T } {
  return { type: 'object', properties: mixin };
}
